/** 성향분석 > 서브 목차 */
export const CONTENTS = [
  { id: 1, title: '📖 성향분석 안내서' },
  { id: 2, title: '' },
  { id: 3, title: '1. 오행의 기운 흐름' },
  { id: 4, title: '' },
  { id: 5, title: '2. 성향 종합 분석' },
  { id: 6, title: '3. 나를 이루는 오행' },
  { id: 7, title: '4. 음양으로 본 성향' },
  { id: 8, title: '5. 성향이 향하는 방향' },
  { id: 9, title: '' },
  { id: 10, title: '6. 정보수집 스타일' },
  { id: 11, title: '' },
  { id: 12, title: '7. 나의 판단 스타일!' },
  { id: 13, title: '' },
  { id: 14, title: '8. 나의 관계 스타일!' },
  { id: 15, title: '' },
  { id: 16, title: '9. 발전의 방향' },
  { id: 17, title: '' },
  { id: 18, title: '10. 에너지를 주는 기운' },
  { id: 19, title: '' },
  { id: 20, title: '11. 성향 종합 분석' },
  { id: 21, title: '' },
  { id: 22, title: '' },
];

/** 성향분석 > 페이지네이션 > 메인 목차 인덱스 - 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1,
  1: 3,
  2: 5,
  3: 6,
  4: 7,
  5: 8,
  6: 10,
  7: 12,
  8: 14,
  9: 16,
  10: 18,
  11: 20,
};
